import { render, staticRenderFns } from "./CPcBanner.vue?vue&type=template&id=66630c8e&"
import script from "./CPcBanner.vue?vue&type=script&lang=ts&"
export * from "./CPcBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports